import ReactGA from "react-ga4";

const GA_ID = "G-K0B6FTWX89";

let initialized = false;

export const initGA = () => {
  if (initialized) return;
  ReactGA.initialize(GA_ID);
  initialized = true;
};

export const trackPage = (path: string, title?: string) => {
  if (!initialized) return;
  ReactGA.send({ hitType: "pageview", page: path, title: title });
};

type EventParams = Record<string, string | number | boolean | null | undefined>;

export const trackEvent = ({
  name,
  params,
}: {
  name: string;
  params: EventParams;
}) => {
  if (!initialized) return;
  ReactGA.event(name, params);
};

// Garde SSR : `window` n'existe pas côté serveur (Node). Sans ce guard, l'affectation
// top-level casse le bundle SSR (`window is not defined`, Pitfall 2).
if (typeof window !== "undefined") {
  window.trackEvent = trackEvent;
}
